module.exports = __webpack_public_path__ + "assets/star_popular_yellow-df586e.svg";